import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";

import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { ReturnService } from "../../../services/return.service";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "addEditPurchaseReturn",
  templateUrl: "./addEditPurchaseReturn.html",
})
export class AddEditPurchaseReturn {
  row: any;
  data: any;
  returndata: any = {};
  partyList: any;
  barcodeList: any;
  designList: any;
  reasonList: any;
  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  date_check = false;
  temp_check = false;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];

    let returndata = Object.assign({}, val["data"]);
    this.returndata = returndata;
    if (this.mode == "Edit" || this.mode == "View") {
      this.loadeditreturnlist();
      this.returndata.po_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      //this.returndata.party_name = returndata.party_name;
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("invForm") invForm;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private returnservice: ReturnService,
    public datePipe: DatePipe,
    private salesinvservice: SalesInvoiceService,
    public toasterService: ToasterService,
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      quality: "",
      type: "",
      color: "",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
      return_reason: "",
    };
    this.data = {
      returnList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.returnList.push(row);
  }
  ngOnInit() {
    this.tableScroll();
    this.partylist();
    if (this.mode == "Add") {
      this.returndata.return_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.returndata.comment = "";
      // this.getAuto();
    }
  }

  tableScroll() {
    $(".purreturn").height(window.innerHeight - 60);
    $(".returnbody").height(window.innerHeight - 400);
    $(".returnbody").width(window.innerWidth - 30);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#party_name").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design_no = this.data.returnList[ind]["design_no"],
      quality = this.data.returnList[ind]["quality"],
      type = this.data.returnList[ind]["type"],
      color = this.data.returnList[ind]["color"],
      a_color = this.data.returnList[ind]["a_color"],
      //  width = this.data.designList[ind]['width'],
      mtrs = this.data.returnList[ind]["mtrs"],
      qty = this.data.returnList[ind]["qty"],
      rate = this.data.returnList[ind]["rate"],
      amt = this.data.returnList[ind]["amt"];

    let nxtRow = $("#row-" + ind).next("tr");
    // let data = this.isRowEmpty(ind);
    if (fld == "barcode" && nxtRow.length == 0) {
      for (let i = 0; i < this.data.returnList.length; i++) {
        if (ind + 1 == this.data.returnList.length) {
          let rowdetail = Object.assign({}, this.row);

          this.data.returnList.push(rowdetail);
          nxtInd = this.data.returnList.length - 1;
        }
      }
    }

    setTimeout(() => {
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  isRowEmpty(ind) {
    let data = this.data.returnList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    if (this.data.returnList.length > 1) {
      this.data.returnList.splice(ind, 1);

      if ($("#" + fld + "-" + (ind - 1)).length > 0) {
        $("#" + fld + "-" + (ind - 1)).focus();
      } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
        $("#" + fld + "-" + (ind + 1)).focus();
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
   //invoice
    // if (this.temp_check == true) {
    //   let params = {
    //     trans_type: "textileRetail",
    //     date: this.returndata.return_date,
    //   };

    //   this.salesinvservice.getAutoNumber(params).then((res: any) => {
    //     this.returndata.debit_no = res.auto_no;
    //     this.onSaveReturn();

    //   });
    //   this.returndata.ret_type = "return_invoice"
    // }
    // // debit note
    // else if (this.temp_check == false) {
    //   this.returnservice.getAuto({}).then((res: any) => {
    //     this.returndata.debit_no = res;
    //     this.onSaveReturn();

    //   });
    //   this.returndata.ret_type = "return_debit"

    // }
    this.temp_check = false
    this.returnservice.getAuto({}).then((res: any) => {
      this.returndata.debit_no = res;
      this.onSaveReturn();

    });
    this.returndata.ret_type = "return_debit"
    

  }
  partylist() {
    this.returnservice.partylist({}).then((res: any) => {
      this.partyList = res.data;
    });
  }

  reasonlist() {
    this.returnservice.reasonlist({}).then((res: any) => {
      this.reasonList = res.data;
    });
  }
  onClickParty(party_name) {
    let partyList = _.filter(this.partyList, { party_name: party_name });
    this.returndata.party_id = partyList[0]["party_id"];
    let params = {
      party_id: this.returndata.party_id,
    };
    this.returnservice.barcodelist(params).then((res: any) => {
      this.barcodeList = res.data;
    });
    this.reasonlist();
  }

  onClickBarcode(barcode, ind) {
    let params = {
      barcode: barcode,
    };



    this.returnservice.designlist(params).then((res: any) => {
      this.designList = res.data;
      if (res.data[0].month_days == '0000-00-00') {
        swal("ERROR", "Inv Date Is Invalid For That Barcode!", "error")
        this.data.returnList[ind].barcode = "";
      }
      else if (res.data[0].month_days != '0000-00-00') {
        //  Debit No Generation
        if (res.data[0].month_days > this.returndata.return_date) {
          this.date_check = false;
        }
        //Invoice No Generation
        else if (res.data[0].month_days < this.returndata.return_date) {
          this.date_check = true;

        }
        // First Time to Set The Initial Value(less Or Greater From Entry_Date)
        if (ind == 0) {
          this.temp_check = this.date_check;

        }

        if ((ind == 0 || (this.temp_check == this.date_check)) && res.data[0].month_days != '0000-00-00') {
          this.data.returnList[ind].p_design_no = this.designList[0].des_no;
          this.data.returnList[ind].design_no = this.designList[0].design_no;
          this.data.returnList[ind].po_no = this.designList[0].po_no;
          this.data.returnList[ind].width = this.designList[0].recvd_width;
          this.data.returnList[ind].act_mtrs = this.designList[0].act_mtrs;
          this.data.returnList[ind].avl_mtrs = this.designList[0].avl_mtrs;
          this.data.returnList[ind].rate = this.designList[0].rate;
          this.data.returnList[ind].inv_no = this.designList[0].inv_no;
          this.data.returnList[ind].inv_date = this.designList[0].inv_date;
        }
        //Allow Only For That Initial Value == Current Value
        else {
          swal("Please Enter Same set!!")
          this.data.returnList[ind].barcode = "";

        }

        console.log(this.temp_check, "for Row Check", this.date_check, res.data[0].month_days)
      }
    });


  }
  calctot(event, ind) {
    let returnData = this.data.returnList[ind];
    let rate = returnData.rate;
    let act_mtrs = returnData.act_mtrs;
    let avl_mtrs = returnData.avl_mtrs;
    let rtn_mtrs = returnData.rtn_mtrs;
    if (rtn_mtrs > avl_mtrs) {
      let that = this;
      that.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "error".toUpperCase(),
        body: "Rtn.mtrs should be less than Act.mtrs",
      });
      returnData.amount = 0;
      this.calcTotal();
    } else {
      this.calcamount(ind);
    }
  }
  calcamount(ind) {
    let returnData = this.data.returnList[ind];
    let rate = returnData.rate;
    let act_mtrs = returnData.act_mtrs;
    let avl_mtrs = returnData.avl_mtrs;
    let rtn_mtrs = returnData.rtn_mtrs;

    //  let rate_per_mtr = parseFloat((rate / act_mtrs).toFixed(2));
    returnData.amount = parseFloat((rate * rtn_mtrs).toFixed(2));
    if (isNaN(returnData.amount)) {
      returnData.amount = 0;
    }
    this.calcTotal();
  }

  calcTotal() {
    let returnData = this.data.returnList;
    let totalamt = 0.0;
    let totmtr = 0.0;

    for (let i = 0; i < returnData.length; i++) {
      let ret = returnData[i];
      totalamt += parseFloat(ret.amount);
      totmtr += parseFloat(ret.rtn_mtrs) ? parseFloat(ret.rtn_mtrs) : 0;

    }
    if (isNaN(totalamt)) {
      totalamt = 0;
      totmtr = 0;

    }
    this.returndata.totalamt = parseFloat(totalamt.toFixed(2));
    this.returndata.totmtr = parseFloat(totmtr.toFixed(2));
    if (this.returndata.disc_per > 0) {
      this.returndata.discamt =
        (this.returndata.totalamt * this.returndata.disc_per) / 100;
      this.returndata.discamt = parseFloat(this.returndata.discamt.toFixed(2));
    }
    else {
      this.returndata.discamt = 0;
    }
   if(!this.returndata.trans_amt){
    this.returndata.trans_amt = 0;
   }
    if (this.returndata.tax_per > 0) {
      this.returndata.taxamt =
        ((this.returndata.totalamt - this.returndata.discamt + this.returndata.trans_amt) * this.returndata.tax_per) / 100;
      this.returndata.taxamt = parseFloat(this.returndata.taxamt.toFixed(2));
    }
    else {
      this.returndata.taxamt = 0;
    }
    this.returndata.retamt = (this.returndata.totalamt - this.returndata.discamt) + this.returndata.trans_amt + this.returndata.taxamt;

    this.returndata.retamt = parseFloat(this.returndata.retamt.toFixed(2));

    // this.returndata.retamt = Math.round(this.returndata.retamt);

  }
  // calcdiscTotal(){
  //   this.returndata.discamt =
  //       (this.returndata.totalamt * this.returndata.disc_per) / 100;
  //     this.returndata.discamt = parseFloat(this.returndata.discamt.toFixed(2));
  // }
  getRoundOff() {
    this.returndata.retamt = ((this.returndata.totalamt - this.returndata.discamt) + this.returndata.trans_amt + this.returndata.taxamt) + this.returndata.round_off

  }
  oncheckemptyrow() {
    let gnr = this.data.returnList;
    let returnList = [];
    for (let i = 0; i < gnr.length; i++) {
      if (gnr[i].design_no != "") {
        returnList.push(gnr[i]);
      }
    }
    this.data.returnList = returnList;

    this.getAuto();



  }

  onSaveReturn(): void {

    let params: any = Object.assign({}, this.returndata);
    params["tabevent"] = undefined;
    params["mode"] = this.mode;
    params["data"] = JSON.stringify(this.data);
    params["return_date"] = this.datePipe.transform(
      params["return_date"],
      "yyyy-MM-dd"
    );
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Return?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.returnservice
        .saveReturn(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            // that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
              that.saveEvent.emit();
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  loadeditreturnlist() {
    let params = {
      return_id: this.returndata.return_id,
    };
    this.returnservice.getEditReturnList(params).then((res: any) => {
      this.data.returnList = res.data;
      this.calcTotal();
      this.getRoundOff();
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchaseReturn/addEditPurchaseReturn.ts